module.exports = __webpack_public_path__ + "img/TLS.b2792074.svg";